
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    src: {
      type: String,
      required: true
    }
  }
})

// export default class LazyImage extends mixins(WithCampaignConstants) {
export default class LazyImage extends Vue {
  show = false;
  src: string;

  get imageSrc() {
    let replacedSrc = this.src;
    if (this.src.match(/^ipfs:\/\//)) {
      replacedSrc = replacedSrc.replace('ipfs://ipfs/', 'https://ipfs.io/ipfs/');
      replacedSrc = replacedSrc.replace('ipfs://', 'https://ipfs.io/ipfs/');
    }

    return replacedSrc;
  }

  mounted() {
    //@ts-ignore
    this.$refs.image!.addEventListener(
      'load',
      () => {
        this.show = true;
      },
      false
    );
  }
}
